export const defaultNFTSvg = (
  <svg
    data-testid="ock-defaultNFTSvg"
    role="img"
    aria-label="loading"
    width="100%"
    height="100%"
    viewBox="0 0 527.008 525"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      fill="#F3F4F6"
      width="100%"
      height="100%"
      className="fill-ock-background-alternate"
    />
    <path
      d="M232.062 258.667C232.062 268.125 236.209 276.614 242.783 282.417H284.675C291.249 276.614 295.396 268.125 295.396 258.667C295.396 241.178 281.218 227 263.729 227C246.24 227 232.062 241.178 232.062 258.667ZM265.697 253.74L276.646 257.792L265.697 261.843L261.646 272.792L257.594 261.843L246.646 257.792L257.594 253.74L261.646 242.792L265.697 253.74ZM274.146 237.792L276.172 243.266L281.646 245.292L276.172 247.317L274.146 252.792L272.12 247.317L266.646 245.292L272.12 243.266L274.146 237.792Z"
      fill="#6B7280"
      className="fill-ock-background-reverse"
    />
    <path
      d="M287.479 288.25H240.813L234.979 297H293.312L287.479 288.25Z"
      fill="#6B7280"
      className="fill-ock-background-reverse"
    />
  </svg>
);
